/** Espelha ATS.Hub.Lib.DFe.Enums.StatusServicoSefazEnum. */
export enum StatusServicoSefazEnum {
  Desconhecido = 0,
  EmOperacao = 1,
  ParalisadoTemporariamente = 2,
  ParalisadoSemPrevisao = 3,
}
